import React from "react";
import { Outlet, useParams, BCMSRecord, useBCMSContext, useRoute } from '@bcm-dev/bcms-vite';
import { Transaction } from "model";

import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import TabsContainer, { TabItem } from "components/shared/containers/TabsContainer";

import "./styles.css";

/**
 * @function CardOnFilePage
 * @return {React.Component}
 * @exported true
 * @description The main component for CardOnFilePage
 */
export default function CardOnFilePage(props) {
  const cardID = useParams().cardID ?? "0";
  const controller = useBCMSContext();
  const navigate = useRoute();

  BCMSRecord.globalControllerFor([ Transaction ], controller);

  const recurringRoutes = [ "/home/cardonfile/recurringpayments", "/home/cardonfile" ];
  const onFileRoutes = [ "/home/cardonfile/cardonfile" ];

  const recurringLink = `/home/cardonfile/recurringpayments/${ cardID }`;
  const onFileLink = `/home/cardonfile/cardonfile/${ cardID }`;

  return (
    <MainContentContainer 
      className="card-on-file-page" 
      header={ 
        <MainContentHeader text="Card on File" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } /> 
      }>
      
      <TabsContainer className="bottom-border">
        <TabItem text="Recurring Payments" route={ recurringLink } activeRoute={ recurringRoutes } activeClass="active-tab active" icon="RefreshIcon" dataPoint="Card_On_File_Recurring"></TabItem>
        <TabItem text="Card on File" route={ onFileLink } activeRoute={ onFileRoutes } activeClass="active-tab active" icon="ShoppingCartIcon" dataPoint="Card_On_File_Card"></TabItem>
      </TabsContainer>
      <div className="tab-content-container">
        <Outlet/>
      </div>
    </MainContentContainer>
  );
}